module.exports = __webpack_public_path__ + "img/emotion.fa8ff7a.jpg";